// Allow redux to dispatch multiple actions via Array

/**
 * @param {Object} param
 * @param {Object} param.dispatch
 * @returns {Function}
 */
export default function multi({ dispatch }) {
  return next => action => (
    Array.isArray(action)
      ? action.filter(Boolean).map(dispatch)
      : next(action)
  );
}
